module.exports = __webpack_public_path__ + "static/media/zip.1362bd54.svg";